import React from 'react'
import bistromenuitemStyles from './bistromenuitem.module.sass'

export default props => {
  const { item } = props

  return (
    <li className={bistromenuitemStyles.menuitem}>
      <strong className={bistromenuitemStyles.name}>{item.item_name}</strong>
      <p className={bistromenuitemStyles.desc}>{item.item_description}</p>
      <span className={bistromenuitemStyles.price}>{`$${item.price}`}</span>
    </li>
  )
}
